import type { FunctionComponent } from 'react'
import { useState } from 'react'
import styled from 'styled-components'
import { PANO_LABELS } from '../../../../pages/MapPage/components/PanoramaViewer/constants'
import { getStreetViewUrl } from '../../../../pages/MapPage/components/PanoramaViewer/panorama-api/panorama-api'
import Clock from '../../../assets/icons/Clock.svg'
import {
  locationParam,
  panoHeadingParam,
  panoTagParam,
} from '../../../../pages/MapPage/query-params'
import useParam from '../../../hooks/useParam'
import Icon from '../../Icon/Icon'
import PanoramaMenuItem, {
  FontStyledContextMenuItem,
} from '../../../../pages/MapPage/components/PanoramaViewer/PanoramaMenuItem'
import ContextMenu from '../../ContextMenu/ContextMenu'
import ExternalLink from '../../../assets/icons/externalLink.svg'
import ChevronDown from '../../../assets/icons/chevronDown.svg'

const getLabel = (id: string): string =>
  PANO_LABELS.find(({ id: labelId }) => labelId === id)?.label || PANO_LABELS[0].label

const StyledContextMenu = styled(ContextMenu)`
  z-index: 401; // on top of other buttons if opened

  & > * {
    max-height: 230px; // A bit arbitrary value, but this will prevent to overlap the menu on other UI elements
    overflow: auto;
    width: 190px;
  }
`

const PanoramaMenuControl: FunctionComponent = () => {
  const [location] = useParam(locationParam)
  const [panoHeading] = useParam(panoHeadingParam)
  const [panoTag] = useParam(panoTagParam)
  const [open, setOpen] = useState(false)

  const handleOpenPanoramaExternal = () => {
    setOpen(false)
    if (location && panoHeading) {
      const url = getStreetViewUrl([location.lat, location.lng], panoHeading)
      window.open(url, '_blank')
    }
  }

  return (
    <StyledContextMenu
      arrowIcon={<ChevronDown />}
      icon={<Clock />}
      label={getLabel(panoTag)}
      open={open}
      onClick={() => setOpen((currentValue) => !currentValue)}
    >
      {PANO_LABELS.map((item, index) => (
        <PanoramaMenuItem
          active={panoTag === item.id}
          index={index}
          item={item}
          key={item.id}
          onSelect={() => setOpen(false)}
        />
      ))}
      <FontStyledContextMenuItem
        key="google-street-view"
        role="button"
        onClick={handleOpenPanoramaExternal}
      >
        <Icon padding={4} inline size={16}>
          <ExternalLink />
        </Icon>
        Google Street View
      </FontStyledContextMenuItem>
    </StyledContextMenu>
  )
}

export default PanoramaMenuControl
